// @generated by protoc-gen-connect-query v2.2.0 with parameter "target=ts"
// @generated from file bffuser/v1/procurement_plan_service.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import { ProcurementPlanService } from "./procurement_plan_service_pb";

/**
 * ListProcurementPlans returns the demand-procurement plan list-screen
 * rows for the authenticated organization. When include_all_versions is
 * false (= default / zero value), only the latest version of each
 * submission is returned.
 *
 * @generated from rpc bffuser.v1.ProcurementPlanService.ListProcurementPlans
 */
export const listProcurementPlans = ProcurementPlanService.method.listProcurementPlans;

/**
 * GetProcurementPlanDetail returns the full detail of a single
 * demand-procurement plan submission, including 48-slot demand values,
 * procurement / sales breakdown rows, and the previous submitted version
 * for diff display. All data is returned in a single RPC to minimise
 * round-trips (主要意思決定 §5).
 *
 * @generated from rpc bffuser.v1.ProcurementPlanService.GetProcurementPlanDetail
 */
export const getProcurementPlanDetail = ProcurementPlanService.method.getProcurementPlanDetail;

/**
 * GetProcurementPlanByFilter looks up a single demand-procurement plan
 * submission by (target_period_start_date, area_code, bg_code[,
 * timeframe]) instead of its UUID, returning the same full detail payload
 * as GetProcurementPlanDetail plus the BG's member (小売事業者) list. Used
 * by the detail screen's filter bar (procurement-plan-detail-filter design
 * §4 主要意思決定 "API 設計") when the user changes the target date or
 * area while viewing a plan. Returns NOT_FOUND when no submission matches
 * the filter.
 *
 * @generated from rpc bffuser.v1.ProcurementPlanService.GetProcurementPlanByFilter
 */
export const getProcurementPlanByFilter = ProcurementPlanService.method.getProcurementPlanByFilter;

/**
 * CreateProcurementPlan triggers the creation of a new demand-procurement
 * plan submission. The BFF handler resolves organization_id from the eauth
 * session and forwards the request to the backend CreatePlanSubmission RPC.
 * On success the status is GENERATING; the backend worker transitions it to
 * GENERATED once assembly from the three sources is complete.
 *
 * @generated from rpc bffuser.v1.ProcurementPlanService.CreateProcurementPlan
 */
export const createProcurementPlan = ProcurementPlanService.method.createProcurementPlan;

/**
 * DownloadProcurementPlanXml returns the plan XML content and its OCCTO
 * BP-規格ファイル名 for the specified plan submission. The BFF handler
 * resolves organization_id from the eauth session.
 *
 * @generated from rpc bffuser.v1.ProcurementPlanService.DownloadProcurementPlanXml
 */
export const downloadProcurementPlanXml = ProcurementPlanService.method.downloadProcurementPlanXml;

/**
 * SubmitProcurementPlan submits a demand-procurement plan submission to the
 * OCCTO portal asynchronously: it enqueues the submission and returns
 * immediately with status SUBMITTING. The BFF handler resolves
 * organization_id from the eauth session and forwards the call to the
 * backend gRPC PlanSubmissionService.EnqueuePlanSubmission RPC. The
 * resident SendWorker settles the enqueued attempt to SUBMITTED / REJECTED
 * / SUBMIT_FAILED; the frontend re-fetches GetProcurementPlanDetail to
 * observe the terminal status.
 *
 * @generated from rpc bffuser.v1.ProcurementPlanService.SubmitProcurementPlan
 */
export const submitProcurementPlan = ProcurementPlanService.method.submitProcurementPlan;

/**
 * IssueProcurementPlanXmlUploadUrl returns a one-time upload token and a
 * presigned PUT request the browser sends the XML / ZIP to directly, plus
 * the size limit the browser checks before sending. It forwards to the
 * backend gRPC PlanSubmissionService.IssuePlanSubmissionImportUploadUrl,
 * fixed to kind=PLAN_SUBMISSION_KIND_DEMAND_PROCUREMENT; the BFF handler
 * resolves organization_id from the eauth session.
 *
 * @generated from rpc bffuser.v1.ProcurementPlanService.IssueProcurementPlanXmlUploadUrl
 */
export const issueProcurementPlanXmlUploadUrl = ProcurementPlanService.method.issueProcurementPlanXmlUploadUrl;

/**
 * UploadProcurementPlanXml synchronously imports the OCCTO 提出フォーマット
 * XML (or a ZIP containing exactly one XML) the browser uploaded with the
 * IssueProcurementPlanXmlUploadUrl response, naming it by upload_token. It
 * forwards to the backend gRPC PlanSubmissionService.ImportPlanSubmission
 * RPC, fixed to kind=PLAN_SUBMISSION_KIND_DEMAND_PROCUREMENT. The BFF
 * handler resolves organization_id from the eauth session; file_name is not
 * carried (the completion dialog uses the frontend's local File.name, not a
 * server round-trip). On success the returned status is always GENERATED
 * (the import is synchronous — contrast CreateProcurementPlan's GENERATING).
 *
 * @generated from rpc bffuser.v1.ProcurementPlanService.UploadProcurementPlanXml
 */
export const uploadProcurementPlanXml = ProcurementPlanService.method.uploadProcurementPlanXml;
